import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'your-azure-client-id',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'your-tenant-id'}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000',
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email']
};

export const apiRequest = {
  scopes: ['api://your-api-scope/access_as_user']
};